import React from "react";
import * as Lucide from "lucide-react";

// Renders a lucide icon by string name from mock data
export default function Ico({ name, ...props }) {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp {...props} />;
}
